import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState, useEffect } from 'react';
var MESSAGE_TYPE = 'embeddedConfluenceVisibleHeight';
export var useIframeVisibleHeight = function useIframeVisibleHeight() {
  // The initial height is arbitrarily set to 1000
  var _useState = useState(1000),
    _useState2 = _slicedToArray(_useState, 2),
    visibleHeight = _useState2[0],
    setVisibleHeight = _useState2[1];
  useEffect(function () {
    var contentSizeHandler = function contentSizeHandler(postMessage) {
      var data = postMessage.data;
      if ((data === null || data === void 0 ? void 0 : data.type) === MESSAGE_TYPE && data !== null && data !== void 0 && data.value) {
        setVisibleHeight(data.value);
      }
    };
    window.addEventListener('message', contentSizeHandler);
    return function () {
      window.removeEventListener('message', contentSizeHandler);
    };
  }, []);
  return {
    visibleHeight: visibleHeight
  };
};